var UserAPI = require('../../common/api/user');
var ApplicationsAPI = require("../../common/api/application");
var RepositoryAPI = require("../../common/api/repository");
var DonationsAPI = require("../../common/api/donation");

var _ = require("underscore");
var moment = require("moment");

module.exports = function ($scope, $stateParams, ngDialog, $window, $rootScope) {
  var vm = this;
  vm.barometer = {};
  vm.applicationId = "";
  vm.fundraiserProfileId = "";
  vm.isOwner = false;
  vm.donations = [];
  vm.comments = [];

  vm.toggleEventDetails = function (event) {
    event.expanded = !event.expanded;
  };

  vm.init = function () {
    return UserAPI.GetFundraisingProfile($stateParams.id).then(function (result) {
      vm.profile = result;
      if (vm.profile) {
        vm.barometer.left = vm.profile.raised;
        vm.barometer.right = vm.profile.totalRequested - vm.profile.raised;
        vm.barometer.divider = vm.profile.totalRequested;

        var perc = Math.floor((vm.profile.raised  * 100) / vm.profile.totalRequested);
        if (perc <= 0) {
          vm.barometer.percentage = 0;
        } else {
          vm.barometer.percentage = perc;
        }

        if (vm.profile.galleryItems) {
          vm.profile.galleryItems.forEach(function (item) {
            var formattedId = (item.blobId).replace(/-/g, '');
            item.url = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(formattedId) + "/" + item.fileName)
          });
        }

        if ($rootScope.auth) {
          var formattedId = (vm.profile.userId).replace(/-/g, '');
          if($rootScope.auth.user_id == formattedId) {
            vm.isOwner = true;
          }
        }
      }
      vm.applicationId = vm.profile.applicationId;
      vm.fundraiserProfileId = vm.profile.id;

      ApplicationsAPI.GetDonations(vm.profile.applicationId, vm.profile.id, "DonationMessageView", 1000).then(function (result) {
        vm.donations = result.results;
        rebuildUpdates();
      });
      ApplicationsAPI.Get(vm.profile.applicationId, "PublicApplicationDetailsView").then(function (result) {
        vm.comments = [];
        result.applicationComments.forEach( function (item) {
          vm.comments.push(item);
        })
        rebuildUpdates();
      });
    });
  }

  vm.togglePublic = function (makePublic) {
    var publicTitle = "Make Fundraising Page Public"
    var publicString = "Making your fundraising page public will allow the public to make donations to your events and activities."
    var hiddenTitle = "Hide Fundraising Page"
    var hiddenString = "Hiding your fundraising page will stop the public from being able to donate to your events or activities. "

    var dialog = ngDialog.openConfirm({
      template: require('./dialogs/togglePage.pug')({
        title: makePublic ? publicTitle : hiddenTitle,
        description: makePublic ? publicString : hiddenString,
        sw: true
      }),
      plain: true,
      disableAnimation: true
    });

    dialog.then(function () {
      vm.profile.isPublic = !vm.profile.isPublic
      UserAPI.UpdateFundraisingProfile(vm.profile).then(function () {
        vm.init();
      });
    });
  }

  vm.submit = function (request) {
    request.userId = vm.profile.userId;
    request.id = vm.profile.id;
    request.applicationId = vm.profile.applicationId
    vm.profile = request;
    return UserAPI.UpdateFundraisingProfile(vm.profile).then(function () {
      return vm.init();
    });
  }

  vm.submitProfilePicture = function () {
    if(Array.isArray(vm.profile.profilePicture)) {
      vm.profile.lowQualityProfilePicture = vm.profile.profilePicture[1];
      vm.profile.profilePicture = vm.profile.profilePicture[0];
    }
    return vm.submit(vm.profile);
  }

  vm.submitGalleryItem = function (request) {
    request.galleryItem.blobId = request.galleryItem.id;
    request.galleryItem.caption = request.caption;
    vm.profile.galleryItems.push(request.galleryItem);

    return UserAPI.UpdateFundraisingProfile(vm.profile).then(function () {
      return vm.init();
    });
  }

  vm.deleteGalleryItem = function (item) {
    for (var i = vm.profile.galleryItems.length - 1; i >= 0; i--) {
      if (vm.profile.galleryItems[i].blobId == item.blobId)
        vm.profile.galleryItems.splice(i, 1);
    }
    UserAPI.UpdateFundraisingProfile(vm.profile).then(function () {
      vm.init();
    });
  }


  var openEventDialog = function (event) {
    var dialog = ngDialog.open({
      template: require("./dialogs/event.pug")(),
      controller: require("./dialogs/event"),
      plain: true,
      closeByDocument: false,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      resolve: {
        event: function () {
          return event ? angular.copy(event) : null;
        }
      }
    });
    return dialog;
  };


  vm.addEvent = function () {
    var dialog = openEventDialog();
    dialog.closePromise.then(function (data) {
      returnedEvent = data.value.event;
      if (!returnedEvent) return;
      returnedEvent.fundraiserProfileId = vm.fundraiserProfileId;
      UserAPI.CreateApplicationEvent(vm.applicationId, returnedEvent).then(function (result) {
        returnedEvent.id = result;
        vm.init();
      });
    });
  };

  vm.editEvent = function (event) {
    var dialog = openEventDialog(angular.copy(event));
    dialog.closePromise.then(function (data) {
      var returnedEvent = data.value.event;
      var returnedAction = data.value.action;
      if (returnedAction == "delete"){
        vm.deleteEvent(event);
      };
      if (returnedAction == "submit") {
        // vm.profile.event = returnedEvent;

        UserAPI.EditApplicationEvent(vm.applicationId, returnedEvent.id, returnedEvent).then(function () {
          return vm.init();
        });
      }
    });
  };

  vm.deleteEvent = function (event) {
    var dialog = ngDialog.open({
      template: require("./dialogs/deleteEvent.pug")(),
      controller: require("./dialogs/deleteEvent"),
      plain: true,
      disableAnimation: true
    });
    dialog.closePromise.then(function (data) {
      if (data.value.action == "submit") {
        return UserAPI.DeleteApplicationEvent(event.id).then(function () {
          return vm.init();
        });
      }
      vm.editEvent(event);
    });
  }

  vm.leaveEvent = function (event) {
    var dialog = ngDialog.open({
      template: require("./dialogs/leaveEvent.pug")(),
      controller: require("./dialogs/leaveEvent"),
      plain: true,
      disableAnimation: true
    });
    dialog.closePromise.then(function (data) {
      if (data.value.action == "submit") {
        return UserAPI.LeaveApplicationEvent(vm.fundraiserProfileId, event.id).then(function () {
          vm.init();
        });
      }
      vm.init();
    }
  )};

    vm.maskDonation = function($event, update){
    $event.preventDefault();

    var promise = ngDialog.openConfirm({
      template: "\
              <p>Are you sure you want to hide the message and anonymise this donation?</p>\
              <div class=\"ngdialog-buttons clearfix\">\
                  <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">No</button>\
                  <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right\" ng-click=\"confirm(1)\">Yes</button>\
              </div>",
      plain: true,
      disableAnimation: true
    });
    promise.then(function () {
      update.isMasked = true;
      DonationsAPI.MaskDonation(update.id).finally(function(){
        return vm.init();
      })
    });
  }

  vm.addComment = function () {
    if (_.any(vm.comments, function (comment) { return comment.editMode; }))
      return;
    vm.comments.push({
      createdDate: moment().format("MMMM Do YYYY, h:mm:ss a"),
      type: "COMMENT",
      editMode: true,
      isFocused: true
    });
    rebuildUpdates();
  };

  vm.editComment = function (comment) {
    comment.editMode = true;
    comment.isFocused = true;
  };

  vm.submitComment = function (comment) {
    comment.editMode = false;
    comment.sendingToServer = true;
    if (comment.id) {
      ApplicationsAPI.UpdateComment(vm.applicationId, comment.id, { text: comment.text }).then(function () {
        comment.sendingToServer = false;
      });
    } else {
      comment.createdDate = moment();
      ApplicationsAPI.CreateComment(vm.profile.applicationId, comment).then(function (result) {
        comment.id = result;
        comment.sendingToServer = false;
      });
    }
    rebuildUpdates();
  };

    var rebuildUpdates = function () {
    _.each(vm.donations, function (update) {
      update.type = "DONATION";
    });
    _.each(vm.comments, function (update) {
      update.type = "COMMENT";
    });
    var combinedUpdates = _.union(vm.donations, vm.comments);
    var sortedUpdates = _.sortBy(combinedUpdates, function (item) {
      return item.createdDate;
    });
    vm.updates = sortedUpdates.reverse();
  };

  vm.getAvatar = function(id){
    return window.conf.ge_api + "users/" + id + "/avatar";
  }

  vm.init();
}
